import React, { useState, useEffect, useRef } from "react";
import WidgetHeader from "../../../../components/Widget/Header";
import { Button, Select } from "@arnsbogroup/react-voicearchive";
import { FormattedDate, FormattedTime } from "react-intl";

const AutomatedOrdersWidget = ({ widget }) => {
  const mounted = useRef(false);

  const [automatedCustomerOptions, setAutomatedCustomerOptions] = useState([])
  const [sortBy, setSortBy] = useState("deadline");
  const [orders, setOrders] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [sortDirection, setSortDirection] = useState(
    localStorage.getItem("AutomatedOrdersWidgetSortDirection") ?? "DESC"
  );

  useEffect(() => {
    mounted.current = true;

    let url = `coordinatordashboard/AutomatedOrders?sortBy=${sortBy}&sortDirction=${sortDirection}`

    if (parseInt(customer?.value) > 0) {
      url = `${url}&customerId=${customer.value}`
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (mounted.current) {
          setOrders(data.data.orders);
        }
      });

    return () => {
      mounted.current = false;
    };
  }, [customer, sortDirection, sortBy]);

  useEffect(() => {
    fetch(`/rest/v2/customer/with-automated-orders`)
      .then((response) => response.json())
      .then(({data}) => {
        let customerOptions = data.map(({ id, name }) => ({ value: id, label: name }))
        customerOptions.unshift({ value: 0, label: "All" })
        setAutomatedCustomerOptions(customerOptions)
      })
  }, [])

  useEffect(() => {
    const prevCustomerId = localStorage.getItem("AutomatedOrdersWidgetCustomerId") ?? 0
    setCustomer(automatedCustomerOptions.find((option) => option.value == prevCustomerId))
  }, [automatedCustomerOptions]);

  const toggleSortDirection = () => {
    const nextSortDirection = sortDirection === "DESC" ? "ASC" : "DESC";
    localStorage.setItem(
      "AutomatedOrdersWidgetSortDirection",
      nextSortDirection
    );
    setSortDirection(nextSortDirection);
  };

  const changeCustomer = (customer) => {
    setCustomer(customer);
    localStorage.setItem("AutomatedOrdersWidgetCustomerId", customer?.value);
  };

  const orderDetails = (uid) => {
    reactHistory.push(`/orders/${uid}`);
  };

  const getDeadline = (order) => {
    const value = new Date(order["deadline"] * 1000);
    return (
      <div>
        <span className="mr-1">
          <FormattedDate value={value} />
        </span>
        <span>
          <FormattedTime value={value} />
        </span>
      </div>
    );
  };

  const getDeadlineStatus = (order) => {
    const diff = order["deadline"] - Math.floor(Date.now() / 1000);
    if (diff > 86400) {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-green-500"
          title="Deadline is not within the next 24 hours"
        ></i>
      );
    } else if (diff > 0) {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-yellow-500"
          title="Deadline is close!"
        ></i>
      );
    } else {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-red-600"
          title="Deadline has passed"
        ></i>
      );
    }
  };

  return (
    <div
      className="bg-white border shadow rounded border-gray-400"
      id="ID_Automated_Orders"
    >
      <WidgetHeader widget={widget} widgetTitle="Automated Orders" />
      <div className="flex justify-between items-center px-4 py-2 border-b">
        <div className="text-opacity-50 hover:text-opacity-100 w-full">
          <Select
            label="Automation:"
            size="xs"
            onChange={(value) => changeCustomer(value)}
            value={customer}
            options={automatedCustomerOptions}
          />
        </div>

        <div className="mt-6 ml-2">
          <Button
            variant="inline"
            size="xs"
            onClick={toggleSortDirection}
            icon={["fa", sortDirection == "DESC" ? "arrow-up" : "arrow-down"]}
          />
        </div>
      </div>

      <div className="w-full text-xs">
        {orders.map((order) => (
          <div
            className={`hover:bg-gray-200 flex border-b ${
              +order?.highlight ? "bg-yellow-100" : ""
            }`}
            onClick={() => orderDetails(order["uid"])}
            title={order["comments"]}
          >
            <div className="shrink-0 px-4 py-2 w-16">
              {order["deal_id"] ? (
                <a
                  href={`https://my.arnsbogroup.com/crm/deal/details/${order["deal_id"]}/`}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                  className="mr-1"
                >
                  D{order["deal_id"]}
                </a>
              ) : (
                order["uid"]
              )}
            </div>
            <div className="grow px-4 py-2 cursor-pointer hover:text-primary truncate">
              {order["name"]}
            </div>
            <div className="shrink-0 px-4 py-2 flex justify-between items-center space-x-4">
              <span>{getDeadline(order)}</span>
              <span className="w-1 inline-block ml-2 mr-1">
                {order["comments"] && (
                  <i className="text-yellow-500 fa fa-info"></i>
                )}
              </span>
              <span className="text-xs w-2 inline-block mr-1">
                {getDeadlineStatus(order)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutomatedOrdersWidget;
